

















import Vue from 'vue';
import MpGroupSettings from '../components/mpgroup/MpGroupSettings.vue';
import massVuex from '../vuex/common';

export default Vue.extend({
  mixins: [massVuex],
  components: {
    MpGroupSettings,
  },
  beforeMount() {
    const href = window.location.href;
    if (href.indexOf('from=filter') === -1) {
      this.$store.commit('INIT_CUSTOMER_FILTER');
    }
  },
});
